import { postRequest } from '@/core';
import { orderTemplates } from '@/requests';

export default async function newOrderTemplateRequest(orderTemplate) {
	let url = orderTemplates.getPath();
	let response = await postRequest(url, {}, orderTemplate);
	return response;
}